import { buildAction } from 'store/actions/actionCreator'

import { CHANGE_CHANNELS_TYPE } from './constants'

export const changeChannelsType = buildAction(CHANGE_CHANNELS_TYPE, 'payload')
